import axios from "axios";

const { REACT_APP_API_BASE_URL } = process.env;

class ConnectionProxy {
  constructor() {
    this.http = axios.create({
      baseURL: `${REACT_APP_API_BASE_URL}/api/v1/`,
      timeout: 10000
    });

    this.headers = {
      tokenType: "",
      accessToken: "",
      client: "",
      expiry: "",
      uid: ""
    };

    this.configure();
  }

  configure = () => {
    this.http.interceptors.request.use(
      config => {
        config.headers.common["Cache-Control"] = "no-cache";
        config.headers.get = {};
        config.headers.get["If-Modified-Since"] = "0";
        config.cache = false;

        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
  };

  getStore = store => {
    this.store = store;
    this.store.subscribe(this.updateInterceptor);
  };

  updateInterceptor = () => {
    const {
      headers: { tokenType, accessToken, client, expiry, uid }
    } = this.store.getState();

    if (this.headers.accessToken === accessToken) {
      return false;
    }

    this.headers = { tokenType, accessToken, client, expiry, uid };

    this.http.defaults.headers.common["token-type"] = tokenType;
    this.http.defaults.headers.common["access-token"] = accessToken;
    this.http.defaults.headers.common["client"] = client;
    this.http.defaults.headers.common["expiry"] = expiry;
    this.http.defaults.headers.common["uid"] = uid;
  };
}

const api = new ConnectionProxy();

export default api;



// WEBPACK FOOTER //
// ./src/api/connectionProxy.js